import { useSelector } from "react-redux";

const PracticeResult = ({ isOpen, onclose }) => {
  const data = useSelector(
    (state) => state.test.questionSummary?.questionsInfo
  );

  const totalMarks = data.reduce(
    (total, question) => total + question.marks,
    0
  );

  const testDetails = useSelector((state) => state.test.testDetails?.data);

  const obtainedMarks = data.reduce((total, question) => {
    if (question.status === "answered" || question.status === "saveAndMark") {
      const answerIsCorrect = question.submittedAns === question.correctAns;
      if (answerIsCorrect) {
        return total + question.marks;
      } else {
        return total - question.negativeMarks;
      }
    } else {
      return total;
    }
  }, 0);
  const percentage = (obtainedMarks / totalMarks) * 100;

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black opacity-50 z-50"></div>}

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div
            className="bg-white rounded-lg p-10 shadow-lg flex gap-5 flex-col justify-center items-center"
            style={{ width: 500 }}
          >
            <h2 className="text-xl font-bold mb-4">Leaderboard</h2>
            <span className="text-orange-500 text-xl font-bold">
              {testDetails?.TestTitle}
            </span>
            <span className="text-lg font-semibold">Your score in Test</span>
            <span className="font-semibold text-xl text-teal-700">
              {percentage.toFixed(2) + "%"}
            </span>
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col bg-gray-100 p-4 rounded-md justify-center gap-2">
                <span className="font-bold">Total Marks</span>
                <span className="text-yellow-500 text-lg text-center">
                  {totalMarks}
                </span>
              </div>
              <div className="flex flex-col bg-gray-100 p-4 rounded-md justify-center gap-2">
                <span className="font-bold">Your Scored</span>
                <span className="text-green-500 text-lg text-center">
                  {obtainedMarks}
                </span>
              </div>
            </div>
            <div className="flex justify-center">
              <button
                onClick={onclose}
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PracticeResult;
